import { render } from "./NewSpecialOrder.vue?vue&type=template&id=503303b0&scoped=true"
import script from "./NewSpecialOrder.vue?vue&type=script&lang=js"
export * from "./NewSpecialOrder.vue?vue&type=script&lang=js"

import "./NewSpecialOrder.vue?vue&type=style&index=0&id=503303b0&scoped=true&lang=css"

import exportComponent from "C:\\Users\\kelvi\\OneDrive\\Desktop\\Projects\\TTC USA Projects\\luna-collection-crm\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-503303b0"]])

export default __exports__